import { scroller } from 'vue-scrollto/src/scrollTo'

export function useScrollTo(section: string, wrapper = 'body') {
  const scrollTo = scroller()

  if (section) {
    scrollTo(`#${section}`, 1, {
      el: `#${section}`,
      container: wrapper,
      offset: -100,
      force: true,
      x: true,
      y: true,
    })
  }
}
